export default {"src":"/_next/static/media/Audio.13f3fd78.svg","height":82,"width":82,"blurWidth":0,"blurHeight":0};